<template>
  <div>
    <div class="row h-100 nf-content">
      <div class="col-12">
        <div class="row d-flex justify-content-center h-100">
          <div class="col-2"></div>
          <div class="col-md-4 float-right my-auto">
            <div class="rounded-circle">
              <img src="../../assets/search.svg" alt="" srcset="" />
            </div>
          </div>
          <div class="col-6 my-auto">
            <div class="row">
              <div class="col-md-6 text-center">
                <h1 class="display-1 text-primary">404</h1>
              </div>
            </div>
            <h1 class="display-4">{{$t("pages.not_found.title")}}</h1>
            <p class="text-muted text-justify">
              {{$t("pages.not_found.msg")}}
            </p>
            <div class="row">
              <div class="col-md-6 text-center">
                <router-link :to="{name: 'default'}" class="btn btn-primary btn-lg">
                  {{ $t("pages.not_found.btn_text") }}
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import appConfig from "@/app.config";
export default {
  name: 'NotFound',
  page: {
    title: "NotFound",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
  },
};
</script>

<style>
html, body {
  background-color: #fff;
}
.nf-content {
  background-color: #fff; 
  margin-top: 8%;
  max-width: 100%;
}
/* 24205b */
.blue-color {
  color: #24205b;
}
</style>